<template>
    <div class="selectCard active-selectCard" @click="handleClick">
        <slot></slot>
        <div>
            <span>{{ label }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectCardComponent",
        props: {
            label: String
        },
        methods: {
            handleClick(event) {
                const el = document.getElementsByClassName(selectCard)
                console.log("element : ", el.classList)
                
            }
        }
    }
</script>

<style scoped>
    .selectCard {
        display: inline-block;
        height: 110px;
        text-align: center;
        border-radius: 15px;
        padding: 0 7.5px;
        width: 100%;
        border: 1px solid #d9dee3;
        background-color: #fff;
    }
    .selectCard:hover{
        background-color: #faf5ed;
        border: 2px solid #ffa409;
    }

    .active-selectCard {
        background-color: #faf5ed;
        border: 2px solid #ffa409;
    }
</style>